/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <LayoutPrincipal>
    <section class="tituloModulo">Configuración General</section>

    <section class="seccion-costos-materiales">
      <div class="header-costos">
        <h3>Configuración de Costos de Materiales (Anclajes y Estructura)</h3>
      </div>

      <div class="material-groups-container costos-flex-three-col">
        <div class="material-group-card" v-for="(grupo, gIndex) in config.materialesEstructura" :key="gIndex">
          <div class="group-header-actions">
            <h4>{{ grupo.nombre }}</h4>
            <div class="group-actions-right">
              <Button v-if="grupo.editing" class="btn-editar-tabla" @click="agregarArticulo(gIndex)"><i
                  class="fa-solid fa-plus"></i></Button>
              <Button v-if="grupo.editing" class="btn-guardar-item"
                @click="toggleEditMode('materialesEstructura', gIndex, false)"><i
                  class="fa-solid fa-floppy-disk"></i></Button>
              <Button v-else class="btn-editar" @click="toggleEditMode('materialesEstructura', gIndex, true)">
                <i class="fa-solid fa-pen-to-square"></i></Button>
            </div>
          </div>

          <div class="material-table-wrapper">
            <table class="costos-table">
              <thead>
                <tr>
                  <th>Artículo</th>
                  <th>Unidad</th>
                  <th class="col-cantidad">Cant.</th>
                  <th class="col-costo-unitario">Costo</th>
                  <th class="col-total">Total</th>
                  <th v-if="grupo.editing" class="col-acciones"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(articulo, aIndex) in grupo.articulos" :key="aIndex">
                  <td v-if="grupo.editing">
                    <input type="text" v-model="articulo.articulo" />
                  </td>
                  <td v-else class="cell-display">{{ articulo.articulo }}</td>

                  <td v-if="grupo.editing">
                    <input type="text" v-model="articulo.unidad" />
                  </td>
                  <td v-else class="cell-display">{{ articulo.unidad }}</td>

                  <td v-if="grupo.editing">
                    <input type="number" min="0" v-model.number="articulo.cantidad" />
                  </td>
                  <td v-else class="cell-display right-align">{{ articulo.cantidad }}</td>

                  <td v-if="grupo.editing">
                    <input type="number" min="0" step="0.01" v-model.number="articulo.costo" />
                  </td>
                  <td v-else class="cell-display right-align">{{ formatCurrency(articulo.costo) }}</td>

                  <td class="total-col">{{ formatCurrency(calcularTotalArticulo(articulo)) }}</td>

                  <td v-if="grupo.editing">
                    <Button class="btn-eliminar" @click="eliminarArticulo(gIndex, aIndex)"> <i
                        class="fa-solid fa-trash"></i></Button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="4" class="footer-label">Total</td>
                  <td class="footer-total">{{ formatCurrency(calcularTotalGrupo(grupo)) }}</td>
                  <td v-if="grupo.editing"></td>
                </tr>
                <tr class="iva-row">
                  <td colspan="4" class="footer-label">Total + IVA (16%)</td>
                  <td class="footer-total-iva">{{ formatCurrency(calcularTotalGrupoIVA(grupo)) }}</td>
                  <td v-if="grupo.editing"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </section>

    <section class="seccion-costos-materiales">
      <div class="header-costos">
        <h3>Configuración de Costos Eléctricos</h3>
      </div>

      <div class="material-groups-container costos-flex-two-col">
        <div class="material-group-card" v-for="(grupo, gIndex) in config.materialesElectricos"
          :key="gIndex + 'electrico'">
          <div class="group-header-actions">
            <h4>{{ grupo.nombre }}</h4>
            <div class="group-actions-right">
              <Button v-if="grupo.editing" class="btn-guardar-item"
                @click="toggleEditMode('materialesElectricos', gIndex, false)"><i
                  class="fa-solid fa-floppy-disk"></i></Button>
              <Button v-else class="btn-editar" @click="toggleEditMode('materialesElectricos', gIndex, true)">
                <i class="fa-solid fa-pen-to-square"></i>
              </Button>
              <Button v-if="grupo.editing" class="btn-editar-tabla" @click="agregarArticuloElectrico(gIndex)"><i
                  class="fa-solid fa-plus"></i>
              </Button>
            </div>
          </div>

          <div class="material-table-wrapper">
            <table class="costos-table">
              <thead>
                <tr>
                  <th>Artículo</th>
                  <th>Unidad</th>
                  <th class="col-cantidad">Cant.</th>
                  <th class="col-costo-unitario">Costo</th>
                  <th class="col-total">Total</th>
                  <th v-if="grupo.editing" class="col-acciones"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(articulo, aIndex) in grupo.articulos" :key="aIndex">
                  <td v-if="grupo.editing">
                    <input type="text" v-model="articulo.articulo" />
                  </td>
                  <td v-else class="cell-display">{{ articulo.articulo }}</td>

                  <td v-if="grupo.editing">
                    <input type="text" v-model="articulo.unidad" />
                  </td>
                  <td v-else class="cell-display">{{ articulo.unidad }}</td>

                  <td v-if="grupo.editing">
                    <input type="number" min="0" v-model.number="articulo.cantidad" />
                  </td>
                  <td v-else class="cell-display right-align">{{ articulo.cantidad }}</td>

                  <td v-if="grupo.editing">
                    <input type="number" min="0" step="0.01" v-model.number="articulo.costo" />
                  </td>
                  <td v-else class="cell-display right-align">{{ formatCurrency(articulo.costo) }}</td>

                  <td class="total-col">{{ formatCurrency(calcularTotalArticulo(articulo)) }}</td>

                  <td v-if="grupo.editing">
                    <Button class="btn-eliminar" @click="eliminarArticuloElectrico(gIndex, aIndex)"> <i
                        class="fa-solid fa-trash"></i></Button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="4" class="footer-label">Total</td>
                  <td class="footer-total">{{ formatCurrency(calcularTotalGrupo(grupo)) }}</td>
                  <td v-if="grupo.editing"></td>
                </tr>
                <tr class="iva-row">
                  <td colspan="4" class="footer-label">Total + IVA (16%)</td>
                  <td class="footer-total-iva">{{ formatCurrency(calcularTotalGrupoIVA(grupo)) }}</td>
                  <td v-if="grupo.editing"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </section>


  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import Button from "@/components/Forms/Button.vue";

export default {
  components: {
    LayoutPrincipal,
    Button,
  },
  data() {
    const articulosAnclajeConcreto = [
      { articulo: 'Taquete tipo arpón 3/8" x 3"', unidad: 'Pza', cantidad: 172, costo: 10.00 },
      { articulo: 'Sellador epóxico fisher', unidad: 'Pza', cantidad: 15, costo: 1000.00 },
    ];

    const articulosAnclajeLaminaOriginales = [
      { articulo: 'Pija punta de broca cabeza hexagonal 3/8" x 1 1/2"', unidad: 'Pza', cantidad: 172, costo: 2.00 },
      { articulo: 'Placa de neopreno 2" x 2"', unidad: 'Pza', cantidad: 172, costo: 1.00 },
      { articulo: 'Sellador SIKA 1A', unidad: 'Pza', cantidad: 12, costo: 250.00 },
      { articulo: 'Rondana plana', unidad: 'Pza', cantidad: 172, costo: 1.00 },
      { articulo: 'Rondana de presión', unidad: 'Pza', cantidad: 172, costo: 1.00 },
    ];

    return {
      config: {
        juntaDirectiva: [
          { cargo: "Director", nombre: "", apellidoPaterno: "", apellidoMaterno: "", firma: null, },
          { cargo: "Subdirector", nombre: "", apellidoPaterno: "", apellidoMaterno: "", firma: null, },
          { cargo: "Secretario", nombre: "", apellidoPaterno: "", apellidoMaterno: "", firma: null, },
          { cargo: "Tesorero", nombre: "", apellidoPaterno: "", apellidoMaterno: "", firma: null, },
          { cargo: "Vocal 1", nombre: "", apellidoPaterno: "", apellidoMaterno: "", firma: null, },
          { cargo: "Vocal 2", nombre: "", apellidoPaterno: "", apellidoMaterno: "", firma: null, },
          { cargo: "Vocal 3", nombre: "", apellidoPaterno: "", apellidoMaterno: "", firma: null, },
        ],
        plazos: {
          anos: 5,
          porcentaje: 10.0,
        },
        materialesEstructura: [
          {
            nombre: 'Anclaje para concreto',
            articulos: articulosAnclajeConcreto,
            editing: false,
          },
          {
            nombre: 'Anclaje para lámina',
            articulos: articulosAnclajeLaminaOriginales,
            editing: false,
          },
          {
            nombre: 'Anclaje para lámina',
            articulos: articulosAnclajeConcreto,
            editing: false,
          },
        ],
        materialesElectricos: [
          {
            nombre: 'Tubería pared delgada 3/4" y accesorios',
            articulos: [
              { articulo: 'Tubería pared delgada metálica galvanizada', unidad: 'Pieza', cantidad: 1, costo: 82.00 },
              { articulo: 'Condulet LB, LR, LL', unidad: 'Pieza', cantidad: 1, costo: 42.00 },
              { articulo: 'Conectores WP', unidad: 'Pieza', cantidad: 1, costo: 19.00 },
              { articulo: 'Coples WP', unidad: 'Pieza', cantidad: 1, costo: 7.00 },
              { articulo: 'Abrazadera de unicanal', unidad: 'Pieza', cantidad: 1, costo: 6.00 },
              { articulo: 'Cople roscado', unidad: 'Pieza', cantidad: 1, costo: 6.00 },
              { articulo: 'Conector glándula', unidad: 'Pieza', cantidad: 1, costo: 12.00 },
            ],
            editing: false,
          },
          {
            nombre: 'Tubería pared delgada 1" y accesorios',
            articulos: [
              { articulo: 'Tubería pared delgada metálica ga', unidad: 'Pieza', cantidad: 1, costo: 164.00 },
              { articulo: 'Condulet LB, LR, LL', unidad: 'Pieza', cantidad: 1, costo: 60.00 },
              { articulo: 'Conectores WP', unidad: 'Pieza', cantidad: 1, costo: 34.00 },
              { articulo: 'Coples WP', unidad: 'Pieza', cantidad: 1, costo: 34.00 },
              { articulo: 'Abrazadera de unicanal', unidad: 'Pieza', cantidad: 1, costo: 10.00 },
              { articulo: 'Cople roscado', unidad: 'Pieza', cantidad: 1, costo: 9.00 },
              { articulo: 'Conector glándula', unidad: 'Pieza', cantidad: 1, costo: 15.00 },
            ],
            editing: false,
          },
          {
            nombre: 'Gabinete de protecciones metálicos',
            articulos: [
              { articulo: '30 cm x 25 cm', unidad: 'Pieza', cantidad: 1, costo: 600.00 },
              { articulo: '40 cm x 30 cm', unidad: 'Pieza', cantidad: 1, costo: 1200.00 },
            ],
            editing: false,
          },
          {
            nombre: 'Cableado THHW por metro',
            articulos: [
              { articulo: 'Calibre (AWG) 12', unidad: 'Metro', cantidad: 1, costo: 10.00 },
              { articulo: 'Calibre (AWG) 10', unidad: 'Metro', cantidad: 1, costo: 15.00 },
              { articulo: 'Calibre (AWG) 8', unidad: 'Metro', cantidad: 1, costo: 23.00 },
              { articulo: 'Calibre (AWG) 6', unidad: 'Metro', cantidad: 1, costo: 32.00 },
            ],
            editing: false,
          },
        ],
      },
      modulosDisponibles: [
        "Dashboard", "Administrador", "COBAES", "Pre-Altas", "Nómina", "Kiosco", "Devolución Fondo de Vivienda", "Préstamo de Vivienda", "Préstamos", "Configuración",
      ],
      empleadoSeleccionado: "",
      permisosPorPuesto: {
        Administrador: [], Contador: [], Secretario: [], Tesorero: [],
      },
      mostrarCalendario: false,
      cumpleaneros: [],
      comunicadosArchivo: [],
      comunicadosTexto: [],
      nuevoComunicado: {
        texto: "",
      },
      diasInhabiles: [],
      vacaciones: [],
      diasInhabilesInput: "",
      vacacionesInput: "",
    };
  },
  mounted() {
    this.permisosPorPuesto.Administrador = [...this.modulosDisponibles];
    this.cargarDatos();
  },
  methods: {
    formatCurrency(value) {
      if (typeof value !== 'number' || isNaN(value)) {
        return '$0.00';
      }
      return value.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });
    },
    calcularTotalArticulo(articulo) {
      const cantidad = typeof articulo.cantidad === 'number' ? articulo.cantidad : 0;
      const costo = typeof articulo.costo === 'number' ? articulo.costo : 0;
      return cantidad * costo;
    },
    calcularTotalGrupo(grupo) {
      if (!grupo || !grupo.articulos) return 0;
      return grupo.articulos.reduce((sum, item) => sum + this.calcularTotalArticulo(item), 0);
    },
    calcularTotalGrupoIVA(grupo) {
      return this.calcularTotalGrupo(grupo) * 1.16;
    },

    /**
     * @param {string} type 
     * @param {number} gIndex
     * @param {boolean} isEditing 
     */
    toggleEditMode(type, gIndex, isEditing) {
      this.config[type][gIndex].editing = isEditing;

      if (!isEditing) {
        const groupName = this.config[type][gIndex].nombre;
        console.log(`Guardando cambios para "${groupName}" en ${type}:`, this.config[type][gIndex].articulos);
        alert(`Cambios para ${groupName} guardados con éxito.`);
      }
    },

    agregarArticulo(gIndex) {
      if (!this.config.materialesEstructura[gIndex].editing) return;

      this.config.materialesEstructura[gIndex].articulos.push({
        articulo: '',
        unidad: 'Pieza',
        cantidad: 1,
        costo: 0.00,
      });
    },
    eliminarArticulo(gIndex, aIndex) {
      if (!this.config.materialesEstructura[gIndex].editing) return;

      if (confirm(`¿Seguro que deseas eliminar el artículo "${this.config.materialesEstructura[gIndex].articulos[aIndex].articulo}"?`)) {
        this.config.materialesEstructura[gIndex].articulos.splice(aIndex, 1);
      }
    },
    guardarCostosMateriales() {
      console.log("Costos de materiales de estructura (general) guardados:", this.config.materialesEstructura);
      alert("Todos los costos de materiales de estructura guardados con éxito.");
    },

    agregarArticuloElectrico(gIndex) {
      if (!this.config.materialesElectricos[gIndex].editing) return;

      const defaultUnit = this.config.materialesElectricos[gIndex].nombre.includes('Cableado') ? 'Metro' : 'Pieza';
      this.config.materialesElectricos[gIndex].articulos.push({
        articulo: '',
        unidad: defaultUnit,
        cantidad: 1,
        costo: 0.00,
      });
    },
    eliminarArticuloElectrico(gIndex, aIndex) {
      if (!this.config.materialesElectricos[gIndex].editing) return;

      if (confirm(`¿Seguro que deseas eliminar el artículo "${this.config.materialesElectricos[gIndex].articulos[aIndex].articulo}"?`)) {
        this.config.materialesElectricos[gIndex].articulos.splice(aIndex, 1);
      }
    },
    guardarCostosElectricos() {
      console.log("Costos de materiales eléctricos (general) guardados:", this.config.materialesElectricos);
      alert("Todos los costos de materiales eléctricos guardados con éxito.");
    },
    guardarPlazos() {
      alert("Configuración de préstamos guardada");
    },
    guardarPermisos() {
      alert("Permisos guardados");
    },
    handleFirma(event, tipo, index) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          this.config[tipo][index].firma = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    borrarFirma(index) {
      this.config.juntaDirectiva[index].firma = null;
    },
    actualizarPermisos() {
      if (this.empleadoSeleccionado === "Administrador") {
        this.permisosPorPuesto.Administrador = [...this.modulosDisponibles];
      }
    },
    abrirCalendario() {
      this.mostrarCalendario = true;
    },
    cerrarCalendario() {
      this.mostrarCalendario = false;
    },
    subirCumpleImagen(event) {
      const file = event.target.files[0];
      if (!file || !file.type.startsWith("image/")) return;
      if (this.cumpleaneros.length >= 1) {
        alert("Solo se permite una imagen de cumpleaños.");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.cumpleaneros = [{
          archivo: reader.result,
          fecha: new Date().toISOString(),
        }];
        this.guardarDatos();
      };
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    eliminarCumpleanero(index) {
      if (confirm("¿Seguro que quieres eliminar esta imagen de cumpleaños?")) {
        this.cumpleaneros.splice(index, 1);
        this.guardarDatos();
      }
    },
    subirComunicadoArchivo(event) {
      const file = event.target.files[0];
      if (!(file && (file.type.startsWith("image/") || file.type === "application/pdf"))) return;
      if (this.comunicadosArchivo.length >= 1) {
        alert("Solo se permite una circular.");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.comunicadosArchivo = [{
          archivo: reader.result,
          fecha: new Date().toISOString(),
        }];
        this.guardarDatos();
        this.agregarNotificacionGlobal("Se subió una nueva circular.");
      };
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    eliminarComunicadoArchivo(index) {
      if (confirm("¿Seguro que quieres eliminar este comunicado de archivo?")) {
        this.comunicadosArchivo.splice(index, 1);
        this.guardarDatos();
      }
    },
    agregarComunicadoTexto() {
      if (this.comunicadosTexto.length >= 3) {
        alert("Solo se permiten 3 comunicados textuales.");
        return;
      }
      if (!this.nuevoComunicado.texto.trim()) {
        alert("El comunicado no puede estar vacío.");
        return;
      }
      this.comunicadosTexto.unshift({
        texto: this.nuevoComunicado.texto.trim(),
        fecha: new Date().toISOString(),
      });
      this.nuevoComunicado.texto = "";
      this.guardarDatos();
      this.agregarNotificacionGlobal("Nuevo comunicado publicado.");
    },
    eliminarComunicadoTexto(index) {
      if (confirm("¿Seguro que quieres eliminar este comunicado textual?")) {
        this.comunicadosTexto.splice(index, 1);
        this.guardarDatos();
      }
    },
    procesarDiasInhabiles() {
      this.diasInhabiles = this.diasInhabilesInput
        .split(",")
        .map(d => parseInt(d.trim()))
        .filter(d => !isNaN(d));
      this.guardarDatos();
    },
    procesarVacaciones() {
      this.vacaciones = this.vacacionesInput
        .split(",")
        .map(d => parseInt(d.trim()))
        .filter(d => !isNaN(d));
      this.guardarDatos();
    },
    guardarDatos() {
      localStorage.setItem("cumpleaneros", JSON.stringify(this.cumpleaneros));
      localStorage.setItem("comunicadosArchivo", JSON.stringify(this.comunicadosArchivo));
      localStorage.setItem("comunicadosTexto", JSON.stringify(this.comunicadosTexto));
      localStorage.setItem("diasInhabiles", JSON.stringify(this.diasInhabiles));
      localStorage.setItem("vacaciones", JSON.stringify(this.vacaciones));
    },
    cargarDatos() {
      const cumpleData = localStorage.getItem("cumpleaneros");
      const archivoData = localStorage.getItem("comunicadosArchivo");
      const textoData = localStorage.getItem("comunicadosTexto");
      const diasData = localStorage.getItem("diasInhabiles");
      const vacsData = localStorage.getItem("vacaciones");

      this.cumpleaneros = cumpleData ? JSON.parse(cumpleData) : [];
      this.comunicadosArchivo = archivoData ? JSON.parse(archivoData) : [];
      this.comunicadosTexto = textoData ? JSON.parse(textoData) : [];
      this.diasInhabiles = diasData ? JSON.parse(diasData) : [];
      this.vacaciones = vacsData ? JSON.parse(vacsData) : [];
      this.diasInhabilesInput = this.diasInhabiles.join(",");
      this.vacacionesInput = this.vacaciones.join(",");
    },
    formatearFecha(fecha) {
      return new Date(fecha).toLocaleDateString("es-MX", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    esPDF(dataUrl) {
      return dataUrl.startsWith("data:application/pdf");
    },
    agregarNotificacionGlobal(mensaje) {
      const notificaciones = JSON.parse(localStorage.getItem('notificaciones')) || [];
      notificaciones.push({
        titulo: 'Nuevo Comunicado',
        mensaje,
        fecha: new Date().toISOString()
      });
      localStorage.setItem('notificaciones', JSON.stringify(notificaciones));
      window.dispatchEvent(new Event('storage'));
    },
  },
};
</script>

<style scoped>
.tituloModulo {
  font-size: 25px;
  color: #2a428c;
  font-weight: bolder;
  font-style: italic;
  margin-bottom: 20px;
  padding-left: 20px;
}

.tarjetas-horizontal-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
}

.tarjeta-miembro {
  flex: 1 1 220px;
  max-width: 220px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  box-sizing: border-box;
}

.tarjeta-miembro h3 {
  font-size: 18px;
  color: #444;
  margin-bottom: 16px;
  font-weight: 600;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
}

label {
  margin-bottom: 6px;
  font-weight: 600;
}

.input-file-hidden {
  display: none;
}

input[type="text"],
input[type="number"],
select,
textarea {
  padding: 7px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  color: #333;
  resize: none;
  font-family: inherit;
}

.btn-icon-plus {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 100%;
  background-color: #29b9f6;
  color: white;
  font-weight: bold;
  font-size: 24px;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
}

.firma-wrapper {
  position: relative;
  display: inline-block;
  margin-top: 10px;
}

.firma-preview {
  max-height: 80px;
  max-width: 180px;
  border: 1px solid #ccc;
  border-radius: 4px;
  object-fit: contain;
  display: block;
}

.btn-borrar {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff4444;
  border: none;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  line-height: 18px;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  user-select: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-borrar:hover {
  background: #cc0000;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px 20px 20px;
}

button[type="button"].btn-primary {
  padding: 10px 20px;
  background-color: #29b9f6;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  font-weight: 600;
}

button[type="button"].btn-primary:hover {
  background-color: #691c32;
}

.seccion-plazos,
.seccion-permisos,
.seccion-calendario {
  margin-top: 30px;
  background: #fff;
  padding: 15px 20px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
}

.seccion-plazos h3,
.seccion-permisos h3,
.seccion-calendario h3 {
  color: #29b9f6;
  margin-bottom: 15px;
}

.modulos-lista {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: space-between;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f3f3f3;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  color: #29b9f6;
}

.configuraciones-flex {
  display: flex;
  gap: 30px;
  justify-content: space-between;
}

.seccion-plazos,
.seccion-permisos,
.seccion-calendario {
  flex: 1 1 45%;
  min-width: 280px;
}

.btn-container-seccion {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

.seccion-extra {
  margin: 30px 0px 0px;
  padding: 15px 20px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  width: 100%;
}

.seccion-extra h3 {
  color: #29b9f6;
  margin-bottom: 0px;
  margin-top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}

.form-agregar-comunicado {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
}

.form-agregar-comunicadoDos {
  margin-bottom: 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.form-agregar-comunicadoTres {
  margin-top: 16px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
}


.sin-comunicados {
  font-style: italic;
  color: #666;
  margin-top: 20px;
}

.lista-comunicados {
  list-style: none;
  padding: 0;
  max-width: 100%;
}

.lista-comunicados li {
  background: #f3f3f3;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  position: relative;
  color: #29b9f6;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.lista-comunicados .fecha {
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 6px;
}

.lista-comunicados .texto {
  font-size: 14px;
  white-space: pre-wrap;
}

.lista-comunicados .btn-borrar {
  position: absolute;
  top: 8px;
  right: 8px;
  font-weight: bold;
  background: #fff;
  border: none;
  color: #cc0000;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  user-select: none;
}

.lista-comunicados .btn-borrar:hover {
  color: #ff4444;
}

.imagen-preview {
  max-width: 100%;
  max-height: 300px;
  margin-top: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  object-fit: contain;
}

.btn-subir-archivo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  background-color: #29b9f6;
  color: white;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  user-select: none;
  gap: 8px;
  width: fit-content;
}

.btn-subir-archivo:hover {
  background-color: #691c32;
}

.btn-subir-archivoNone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  background-color: white;
  color: white;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  transition: background 0.2s;
  user-select: none;
  gap: 8px;
  width: fit-content;
}

.input-file-hidden {
  display: none;
}

.cotenedorCirBoton {
  display: flex;
  justify-content: space-between;
}

.textarea-comunicado {
  height: 70px;
  padding: 12px 16px;
  font-size: 15px;
  border-radius: 10px;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  resize: none;
  color: #333;
  line-height: 1.5;
  background: white;
}

.seccion-costos-materiales {
  margin-top: 30px;
  background: #fff;
  padding: 15px 20px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
}

.seccion-costos-materiales h3 {
  color: #29b9f6;
  margin-bottom: 0px;
}

.header-costos {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.material-groups-container {
  display: flex;
  gap: 25px;
  margin-top: 15px;
}

.group-actions-right {
  display: flex;
}

.btn-editar-item {
  padding: 5px 10px;
  background-color: #f7a83d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.btn-editar-item:hover {
  background-color: #e5942c;
}

.costos-table .cell-display {
  padding: 7px 10px;
  line-height: 1.5;
}

.material-groups-container.costos-flex-three-col {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 15px;
}

.material-groups-container.costos-flex-three-col .material-group-card {
  flex: 1 1 30%;
  max-width: 32.33%;
  min-width: 200px;
  box-sizing: border-box;
}

.material-groups-container.costos-flex-two-col {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 15px;
}

.material-groups-container.costos-flex-two-col .material-group-card {
  flex: 1 1 calc(50% - 10px);
  max-width: calc(50% - 10px);
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .material-groups-container.costos-flex-three-col,
  .material-groups-container.costos-flex-two-col {
    flex-wrap: wrap;
  }

  .material-groups-container.costos-flex-three-col .material-group-card,
  .material-groups-container.costos-flex-two-col .material-group-card {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: auto;
  }
}


.material-group-card {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 3px 6px #00000029;
}

.group-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f8f8;
  padding: 10px 15px;
}

.group-header-actions h4 {
  font-size: 15px;
  color: #29b9f6;
  margin: 0;
}

.btn-add-item {
  padding: 5px 10px;
  background-color: #29b9f6;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.btn-add-item:hover {
  background-color: #2578a0;
}

.costos-table {
  width: 100%;
  border-collapse: collapse;
}

.costos-table th {
  background-color: black;
  color: white;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 600;
}

.costos-table th.col-cantidad,
.costos-table th.col-costo-unitario,
.costos-table th.col-total {
  font-size: 13px;
  padding: 8px 5px;
}


.costos-table td {
  padding: 5px 10px;
  font-size: 13px;
  vertical-align: middle;
}

.costos-table tbody tr:nth-child(even) {
  background-color: #f8fafc;
}

.costos-table input {
  width: 100%;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);
  font-size: 13px;
}

.costos-table input[type="number"] {
  text-align: right;
}

.total-col {
  text-align: right;
  font-weight: bold;
  color: #333;
}

.costos-table tfoot td {
  padding: 5px 10px;
  font-weight: bold;
  text-align: right;
  border: none;
}

.costos-table .footer-label {
  text-align: right;
  padding-top: 8px;
}

.costos-table .footer-total {
  background-color: #ffff0059;
  border-top: 1px solid #ccc;
}

.costos-table .footer-total-iva {
  background-color: #ffff0080;
  border-top: 1px solid #ccc;
  color: #691c32;
}

.costos-table .iva-row .footer-label {
  border-top: 1px solid #ccc;
}

.material-table-wrapper {
  overflow-x: auto;
}

.seccion-comunicados-flex {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
}

@media (max-width: 1024px) {
  .seccion-comunicados-flex {
    flex-direction: column;
  }
}

.header-costos {
  flex-wrap: wrap;
  gap: 10px;
}

</style>